/**
 * l2-open-drawer-on-add — abre el drawer del carrito tras CUALQUIER /cart/add.js.
 *
 * Por qué existe (1-sep-2026): el tema solo auto-abre el drawer cuando el añadido viene del
 * formulario nativo (cart-drawer.js: atributo `auto-open` + `source === 'product-form-component'`).
 * Los añadidos propios de L2PH —buy-box de cajas, carrusel de upsell del carrito, botones de las
 * landings— van por fetch/XHR contra /cart/add.js y NO emiten ese evento, así que no abrían nada.
 * Hasta ahora eso lo tapaba sin querer el modal de suscripción (`l2-sub-upsell`), que interceptaba
 * todos los add y llamaba a openDrawer(). Al retirar el modal se quedó al aire y el carrito dejó
 * de abrirse. Esto hace SOLO esa parte.
 *
 * Notas:
 * - No se restaura window.fetch al original en ningún momento: si otro script lo re-parchea por
 *   encima seguimos funcionando, pero si alguien lo RESTAURA nos quedamos fuera (ya pasó en LPM
 *   con Searchanise). Por eso se parchea pronto y se deja.
 * - Si el drawer ya está abierto no se hace nada, para no reabrirlo en cada add del carrusel.
 */
(function () {
  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/;

  function drawer() {
    return document.querySelector('cart-drawer-component');
  }

  function abrir() {
    try {
      var cd = drawer();
      if (!cd) return;
      // ya abierto -> no tocar (el <dialog> interno marca open)
      var dlg = cd.refs && cd.refs.dialog;
      if (dlg && dlg.open) return;
      if (typeof cd.open === 'function') cd.open();
      else if (typeof cd.showDialog === 'function') cd.showDialog();
    } catch (e) {}
  }

  // Se espera un tick: l2-cart-sync re-renderiza el drawer tras el add y así abrimos con el
  // contenido ya actualizado, no con la lista anterior.
  function abrirDiferido() {
    setTimeout(abrir, 60);
  }

  var of = window.fetch;
  if (of) {
    window.fetch = function () {
      var p = of.apply(this, arguments);
      try {
        var a = arguments[0];
        var url = a && a.url ? a.url : a;
        var opt = arguments[1];
        var metodo = (opt && opt.method) || (a && a.method) || 'GET';
        if (typeof url === 'string' && ADD_RE.test(url) && metodo.toUpperCase() === 'POST') {
          p.then(function (r) {
            if (r && r.ok) abrirDiferido();
          }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  if (window.XMLHttpRequest) {
    var pr = XMLHttpRequest.prototype,
      oo = pr.open,
      os = pr.send;
    pr.open = function (m, u) {
      this._l2odU = u;
      this._l2odM = m;
      return oo.apply(this, arguments);
    };
    pr.send = function () {
      var x = this;
      if (typeof x._l2odU === 'string' && ADD_RE.test(x._l2odU) && (x._l2odM || '').toUpperCase() === 'POST') {
        x.addEventListener('load', function () {
          if (x.status >= 200 && x.status < 300) abrirDiferido();
        });
      }
      return os.apply(this, arguments);
    };
  }
})();
